export const COMPOSITIONS_PREFIX = "@COMPOSITIONS/"
export const FETCH_COMPOSITIONS = `${COMPOSITIONS_PREFIX}FETCH_COMPOSITIONS`

export enum CompositionType {
  WASTE_ORIGIN = 0,
  SORTING_OUTPUT = 1,
}
